export const FEEDBACK_MOOD_VALUES = [0, 1, 2, 3, 4, 5] as const

export type FeedbackMoodValue = (typeof FEEDBACK_MOOD_VALUES)[number]
